import React from "react";
import TableBase from "./Base";
import moment from "moment";
import { Tooltip, Button } from "antd";

import { DATE_FORMAT_FRONTEND } from "../../constants";
import { getTranslation } from "../../utils/helper";

const GroupsTable = ({ scrollHeight, actionWidth, withAction, setting, ...props }) => {
  const COLUMNS = [
    {
      title: getTranslation(setting, "User Groups", "Group Name"),
      dataIndex: "name",
      width: 150,
      ellipsis: true,
    },
    {
      title: getTranslation(setting, "User Groups", "Users"),
      dataIndex: "users",
      width: 500,
      ellipsis: true,
      render(users) {
        if (!users) return null;
        return users.map(user => (
          <Tooltip key={user._id} placement="top" title={user.email}>
            <Button key={user._id} type="text" className="user">
              {user.name}
            </Button>
          </Tooltip>
        ));
      },
    },
    {
      title: getTranslation(setting, "User Groups", "# of Users"),
      dataIndex: "users",
      width: 120,
      render(value) {
        return value.length;
      },
    },
    {
      title: getTranslation(setting, "User Groups", "Date Added"),
      dataIndex: "createdAt",
      width: 150,
      render(value) {
        return value ? moment(value).locale(setting.systemLanguage).format(DATE_FORMAT_FRONTEND) : "-";
      },
    },
  ];

  if (withAction) {
    COLUMNS.push({
      key: "action",
      width: actionWidth || 100,
      fixed: "right",
      render(record) {
        return withAction(record);
      },
    });
  }

  if (scrollHeight) {
    return <TableBase columns={COLUMNS} scroll={{ x: 991, y: scrollHeight }} {...props} />;
  } else {
    return <TableBase columns={COLUMNS} scroll={{ x: 991 }} {...props} />;
  }
};

export default GroupsTable;
